import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-public-layout',
    templateUrl: './public-layout.component.html',
    styleUrls: ['./public-layout.component.css'],
    standalone: false
})
export class PublicLayoutComponent {


}
